// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"896":"8ebaec70af791c3c","2749":"926894f813fc2e24","5544":"1100af16a53def1b","8281":"bb186e43c418fd48"}[chunkId] + ".js";
};